import ProjectApi from '@/apis/project-api';
import { Component } from 'vue-property-decorator';
import EditorBase from '../editor/EditorBase';
import ScenePageMobile from './ScenePageMobile.vue';
import { IProject } from '@/helpers/editor';

@Component({
  components: {
    ScenePageMobile,
  },
})
export default class SceneRoot extends EditorBase {
  async mounted() {
    if (this.$route.params.projectUuid && !this.selectedProject) {
      const response = await ProjectApi.getProject(this.$route.params.projectUuid);
      if (response.success) {
        this.selectedProject = response.project as IProject;
      }
    }
  }
}
